export default "__VITE_ASSET__893cd40a__"